export const steps = [
  'AllocateBudget',
  'CoreFundPlan',
  'FocusedFundPlan',
  'FollowOnFundPlan',
  'SyndicationsPlan',
  'ReviewPlan',
  'BookCall',
];

export const FundType = Object.freeze({
  CORE: 0,
  FOCUSED: 1,
  SYNDICATION: 2,
  FOLLOW_ON: 3,
});

export const TierType = Object.freeze({
  DIAMOND: 'Diamond Club',
  GOLD: 'Gold Club',
  REGULAR: 'Regular',
});
